import { useChipGroupContext } from './hooks/useChipGroupContext.js';

/** Component showing the number of hidden chips in a chip group. */
export const HiddenCount = () => {
  const { hiddenKeys } = useChipGroupContext();

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{hiddenKeys.length}</>;
};
